<template>


  <div class="block shadow-md block  cursor-grab rounded-md h-auto bg-white">
    <a-spin :spinning="submitting">

      <div style="padding: 5px 10px 5px 10px" class="font-semibold break-words whitespace-pre-line leading-normal">
      <textarea
          class="w-full h-20 rounded-lg border-none flex-1 p-1 placeholder-white placeholder-opacity-75 focus:ring-white"
          v-model="newText"
      />
        <div class="mt-1 flex justify-end text-sm">

          <button
              @click="cancelEdited"
              type="button"
              class="bg-red-400 focus:outline-none mr-2 hover:bg-red-300  hover:border-red-300 text-white font-sm py-1 px-1 border border-red-400 rounded shadow"
          >
            <XIcon class="flex-shrink-0 h-4 w-4 text-white" aria-hidden="true"/>
          </button>
          <button
              type="button"
              @click="addCard"
              class="bg-blue-400 focus:outline-none hover:bg-blue-300 hover:border-blue-300  text-white font-sm py-1 px-1 border border-blue-400 rounded shadow"
          >
            <CheckIcon class="flex-shrink-0 h-4 w-4 text-white" aria-hidden="true"/>
          </button>
        </div>
      </div>
    </a-spin>
  </div>


</template>

<script>

import {ref} from "vue";
import {CheckIcon, PlusIcon, XIcon} from "@heroicons/vue/outline";
import {postAddCard} from "@/Pages/API/retrospective";
import {API} from "@/Pages/API/client";
import {message} from "ant-design-vue";

export default {
  props: {
    isFocused: {
      type: Boolean
    },
    roomId: {
      type: Number
    },
    text: {
      type: String
    },
    id: {
      type: Number,
    },
  },
  emits: ['cancelEdited', 'cardEdited'],
  components: {
    CheckIcon, PlusIcon, XIcon
  },
  data() {
    return {};
  },
  setup(props, {emit}) {
    const submitting = ref(false);
    const newText = ref(props.text);
    const showCard = ref(false);

    function focusedMovement() {
      console.log('sss');
    }

    function cancelEdited() {
      emit('cancelEdited');
    }

    const addCard = () => {

      // lists.value[slistId].cards.push({ text: newText, id: new Date().getTime() });
      submitting.value = true;
      axios
          .patch(route("retrospective.card.edit"), {
            room_id: props.roomId,
            value: newText.value,
            card_id: props.id,
          })
          .then((response) => {
            submitting.value = false;
            if (response.data.success) {
              message.success("Your card is edited");
            } else {
              message.warning(response.data.message, 5);
            }
            emit('cardEdited');
          })
          .catch((error) => {
            submitting.value = false;
            console.log(error);
            message.error("Oops, something went wrong.");
          });
    };

    return {
      focusedMovement,
      cancelEdited,
      submitting,
      showCard,
      newText,
      addCard
    }
  },
  computed: {},
  methods: {}
};
</script>
<style scoped>

.ant-spin-nested-loading {
  height: unset !important;
}
</style>
